<script setup lang="ts">
import FormUsers from '@/pages/admin/users/components/form-users.vue'

definePage({
  meta: {
    navActiveLink: 'admin-users',
    subject: 'users',
    action: 'create',
  },
})
</script>

<template>
  <FormUsers />
</template>
